module.exports = "img/flags/EH.821c7e1.png";